











































































































import { AuthLayoutVueGB } from "@/extensions/layouts/AuthLayoutVueGB";
import { Component, Vue } from "vue-property-decorator";
import CommonFooter from "@/components/navigation/CommonFooter.vue";
import AuthNavigation from "@/components/navigation/AuthNavigation.vue";
import AppError from "@/components/app/AppError.vue";
import { register } from "register-service-worker";

@Component({
  components: { CommonFooter, AuthNavigation, AppError }
})
export default class AuthLayout extends AuthLayoutVueGB {
  async created() {
    if (this.$route.query['ebsError']) {
      Vue.$toast.open({
        message: this.$route.query['ebsError'].toString(),
        type: "ebs"
      });
      this.$route.query['ebsError'] = "0";
    }

    await this.init();
    await this.getBankTariffs();
    await this.getBankNews();
  }

  get windowHref(): string {
    return this.$route.path;
  }
}
